module.exports = __webpack_public_path__ + "static/media/mainimg.88a43b40.png";